import React from 'react';
import { cn } from '../../lib/utils';

export function Badge({ children, tone = 'neutral', className }) {
  const tones = {
    neutral: 'bg-slate-100 text-ink-soft',
    primary: 'bg-primary-light text-primary-dark',
    accent: 'bg-accent-light text-accent-dark',
    success: 'bg-emerald-100 text-emerald-700',
    danger: 'bg-rose-100 text-rose-700',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold font-heading',
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
